<app-nav></app-nav>
<div
  class="page-body-config"
  role="main"
>
  <header>
    <h1 class="page-header">My Profile</h1>
  </header>
  <div
    *ngIf="isFirstTime && !displayTabs"
    class="body-container mx-auto"
  >
    <app-begin-page #beginForm></app-begin-page>
    <div class="action-container">
      <button
        class="btn btn-danger btn-block"
        [disabled]="!this.beginForm.isValid"
        (click)="onBegin()"
      >Begin</button>
    </div>
  </div>
  <div
    id="main-content"
    [ngClass]="{'d-none': !displayTabs}"
  >
    <mat-tab-group
      #tabs
      class="left-stepper"
      [disableRipple]="true"
      [@.disabled]="true"
      [(selectedIndex)]="currIndex"
    >
      <mat-tab label="Contact Details">
        <div class="inner-content" style="padding-right: 2.5rem">
          <div class="content mx-auto">
            <app-contact-details-page
              #cdPage
              [isFirstTime]="isFirstTime"
              (navigateToOtherContacts)="navigateToTabIndex($event)"
            ></app-contact-details-page>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Other Contacts">
        <div class="inner-content" style="padding-right: 2.5rem">
          <div class="content mx-auto">
            <app-other-contacts-page
              #fmPage
              [isFirstTime]="isFirstTime"
              (navigateToCampLocation)="navigateToTabIndex($event)"
            ></app-other-contacts-page>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Camp Locations">
        <div class="inner-content">
          <div class="content mx-auto">
            <app-camp-locations-page
              #clPage
              [isFirstTime]="isFirstTime"
              (navigateToCamperApp)="navigateToTabIndex($event)"
            ></app-camp-locations-page>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Terms & Policies">
        <div class="inner-content">
          <div class="content mx-auto">
            <app-camper-app-page
              #caPage
              [showText]="true"
            ></app-camper-app-page>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<app-footer></app-footer>
